module.exports = __webpack_public_path__ + "img/zeiteinteilung--maximen--i-und-ii-cover.f31c3ae3.jpg";